import { FC, JSX } from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router';
import CssBaseline from '@mui/joy/CssBaseline';
import AppLayout from 'Components/app/AppLayout';
import { appRoutes } from './RouteConfig';
import { ToasterWrapper } from '../Components/ToastWrapper/ToastWrapper';

const AppRoutes: FC = (): JSX.Element => {
  const router = createBrowserRouter([
    {
      path: '/',
      element: (
        <AppLayout>
          <Outlet />
        </AppLayout>
      ),
      children: appRoutes,
    },
  ]);

  return (
    <>
      <CssBaseline />
      <ToasterWrapper />
      <RouterProvider router={router} />
    </>
  );
};

export default AppRoutes;
